<div class="field-activity-container" [ngStyle]="{ 
  'width': config.width, 
  'height': config.height, 
  'padding':  this.config.padding ? this.config.padding : 'unset',
  }">
<div class="field-activity-body dashed-border-left" [ngStyle]="{ left: positionGrid + '%' }">
  <div class="field-activity-row"
    [ngStyle]="{'grid-template-columns': 'repeat(' + (timeItems.length) + ', 1fr)', 'width': width}">
    <div *ngFor="let header of timeItems; let colIndex = index"
      class="dashed-border-right field-activity-column"
      [ngStyle]="styleArray[colIndex]">
        <div class="item-container" *ngFor="let item of [].constructor(iTemsPerInterval); let id = index">
          <div class="activity-item-container" 
            [ngClass]="getItemClass(colIndex, id)"
            [ngStyle]="getItemStyle(colIndex, id)"
            *ngFor="let item of groupedItems[colIndex]?.grid[id]">
            <caremoni-field-activity-item 
              [config]="config" 
              [data]="item?.item">
            </caremoni-field-activity-item>
          </div>
        </div>
      <!-- </ng-container> -->
    </div>
  </div>
</div>
  <div *ngIf="isShowTimePointer" [ngStyle]="{  left: 'calc(' + postionRedLine + '% - '+widthRedLine/2+'px)', width: widthRedLine + 'px' }" class="current-time-line">
  </div> 
</div>